import TermAccordion from '@components/term/TermAccordion';
import useTermCategories from '@hooks/term/useTermCategories';
import { TermDisplayContext } from '@models/term/termCategory';

import styles from './styles.module.scss';

interface Props {
    displayContext: TermDisplayContext;
    noMargin?: boolean;
}

function TermNotes({ displayContext, noMargin }:Props) {
  const termCategories = useTermCategories(displayContext);
  return (
        <footer className={`${styles.container} ${noMargin ? styles.noMargin : ''}`}>
            {termCategories.map((termCategory) => (
                <TermAccordion termCategory={termCategory}
                key={termCategory.id}/>
            ))}
        </footer>
  );
}

export default TermNotes;
